export default __webpack_public_path__ + "static/media/feather_send.1c2f4942.svg";